import { apiCall } from "./service";
import {
  URL_DASHBOARD_SUMMARY,
  URL_ACCOUNT,
  URL_NOTIFICATIONS,
  URL_READ_NOTIFICATION,
  URL_DELETE_NOTIFICATION,
  URL_CREATE_REMINDER,
  URL_UPDATE_REMINDER,
  URL_REMINDERS,
  URL_SNOOZE_REMINDER,
  URL_FETCH_REMINDER,
  URL_DELETE_REMINDER,
  URL_READ_REMINDER,
  URL_UPDATE_ACCOUNT,
  URL_UPDATE_LOGO,
  URL_PJM_DASHBOARD_SUMMARY,
  URL_PRM_DASHBOARD_SUMMARY,
  URL_POM_DASHBOARD_SUMMARY,
  URL_POM_DASHBOARD_GROUPED,
  URL_NOTIFICATION_LINK_REDIRECTION,
} from "./URL";

const buildQueryParams = (queryObject) => {
  const params = new URLSearchParams();
  for (const key in queryObject) {
    const value = queryObject[key];
    if (value !== undefined && value !== null && value !== "") {
      params.append(key, value);
    }
  }

  return params.toString();
};
export const api = {
  dashboardSummaryRequest() {
    return apiCall.get({ url: URL_DASHBOARD_SUMMARY });
  },
  settingsRequest() {
    return apiCall.get({ url: URL_ACCOUNT });
  },
  updateSettingsRequest(params) {
    return apiCall.put({
      url: URL_UPDATE_ACCOUNT,
      isAuthToken: true,
      params: params,
    });
  },
  updateLogoRequest(params) {
    return apiCall.file({ url: URL_UPDATE_LOGO, params: params });
  },
  getNotificationsRequest() {
    return apiCall.get({ url: URL_NOTIFICATIONS });
  },
  createNotificationRequest(params) {
    return apiCall.post({
      url: URL_NOTIFICATIONS,
      isAuthToken: true,
      params: params,
    });
  },
  deleteNotificationRequest(id) {
    return apiCall.delete({ url: `${URL_DELETE_NOTIFICATION}/${id}` });
  },
  markNotificationReadRequest(params) {
    return apiCall.put({
      url: `${URL_READ_NOTIFICATION}`,
      isAuthToken: true,
      params: params.payload,
    });
  },
  getNotificationLinkRedirectionRequest(params) {
    return apiCall.get({
      url: `${URL_NOTIFICATION_LINK_REDIRECTION}?${buildQueryParams(params)}`,
      isAuthToken: true,
      params: params.payload,
    });
  },
  createRemindersRequest(params) {
    return apiCall.post({
      url: URL_CREATE_REMINDER,
      isAuthToken: true,
      params: params,
    });
  },
  createNotificationRequest(params) {
    return apiCall.post({
      url: URL_NOTIFICATIONS,
      isAuthToken: true,
      params: params,
    });
  },
  updateRemindersRequest(params) {
    return apiCall.put({
      url: `${URL_UPDATE_REMINDER}${params.id}`,
      isAuthToken: true,
      params: params.payload,
    });
  },
  getReminderDetailRequest(id) {
    return apiCall.get({ url: `${URL_FETCH_REMINDER}${id}` });
  },
  getRemindersRequest(params) {
    if (params) {
      if (params.query) {
        return apiCall.get({ url: `${URL_REMINDERS}?${params.query}=${true}` });
      }
    }
    return apiCall.get({ url: URL_REMINDERS });
  },
  deleteReminderRequest(id) {
    return apiCall.delete({
      url: `${URL_DELETE_REMINDER}/${id}`,
      isAuthToken: true,
    });
  },
  markReminderReadRequest(params) {
    return apiCall.put({
      url: `${URL_READ_REMINDER}`,
      isAuthToken: true,
      params: params.payload,
    });
  },
  reminderSnoozeRequest(params) {
    return apiCall.put({
      url: `${URL_SNOOZE_REMINDER}${params.id}/snooze`,
      isAuthToken: true,
      params: params.payload,
    });
  },
  pjmDashboardSummaryRequest() {
    return apiCall.get({ url: URL_PJM_DASHBOARD_SUMMARY });
  },
  pjmDashboardDetailRequest(projectId) {
    return apiCall.get({ url: `${URL_PJM_DASHBOARD_SUMMARY}/?projectId=${projectId}` });
  },
  prmDashboardSummaryRequest() {
    return apiCall.get({ url: URL_PRM_DASHBOARD_SUMMARY });
  },
  prmDashboardDetailRequest(programId) {
    return apiCall.get({ url: `${URL_PRM_DASHBOARD_SUMMARY}/?programId=${programId}` });
  },
  pomDashboardSummaryRequest(filters = {}) {
    const qs = buildQueryParams(filters);
    return apiCall.get({ url: qs ? `${URL_POM_DASHBOARD_SUMMARY}?${qs}` : URL_POM_DASHBOARD_SUMMARY });
  },
  pomDashboardDetailRequest(portfolioId, filters = {}) {
    const qs = buildQueryParams({ ...filters, portfolioId });
    return apiCall.get({ url: `${URL_POM_DASHBOARD_SUMMARY}/?${qs}` });
  },
  pomDashboardGroupedRequest(filters = {}, portfolioId) {
    const qs = buildQueryParams(portfolioId ? { ...filters, portfolioId } : filters);
    return apiCall.get({ url: qs ? `${URL_POM_DASHBOARD_GROUPED}?${qs}` : URL_POM_DASHBOARD_GROUPED });
  },
};

export default api;
